import React, { memo } from 'react'
import './Image.scss'

const Image = (props) => {
  const { src, alt, width, height, className = 'img-fluid' } = props
  return <img src={src} alt={alt} width={width} height={height} className={`${className}`} />
}
export default memo(Image)
